<template>
  <button ref="SpButton" :type="htmlType" :disabled="disabled" class="SpButton flex-center pointer" :style="styleC" :class="classC" @click="clickHandler">
    <slot><span class="label">{{ label }}</span></slot>
  </button>
</template>

<script type="text/ecmascript-6">
import { useSize } from '@/mixins/size'
import { computed, toRef } from '@vue/reactivity'
import { useRoute, useRouter } from 'vue-router'
// import {themeType} from './types'
const THEME = {
  primary: 'sp-color-bg-1 sp-color-4',
  primary2: 'sp-color-bg-4 sp-color-1 sp-button-normal sp-color-bd-1-solid-1',
  primary3: 'sp-color-bg-9 sp-color-4',
  blue: 'sp-color-bg-20 sp-color-11',
  normal: 'sp-color-bg-4 sp-color-11 sp-button-normal sp-color-bd-1-solid-7',
  warn: 'sp-color-bg-6 sp-color-11',
  deepWarn: 'sp-color-bg-2 sp-color-4',
  back: 'sp-color-bg-9 sp-color-11',
  backStyle: 'sp-color-bg-9 sp-color-11',
  cancle: 'sp-color-bg-9 sp-color-11',
  cancleLight: 'sp-color-bg-4 sp-color-7 sp-color-bd-7',
  confirm: 'sp-color-bg-4 sp-color-1 sp-color-bd-1',
  gray: 'sp-color-bg-16 sp-color-11',
  yellow: 'color-bg-yellow sp-color-11',
  error: 'btb-error',
  warn1: 'sp-button-warn-1',
  warn1active: 'sp-button-warn-active-1'
}
export default {
  name: 'SpButton',

  components: {
  },

  props: {
    type: {
      type: String,
      default: 'primary'
    },

    comp: { // 内置组合类型按钮
      type: String,
      default: ''
    },

    large: Boolean,

    popStyle: {
      type: Object,
      default: () => {
        return {}
      }
    },

    circle: {
      type: Boolean
    },

    circleRadius: {
      type: String,
      default: ''
    },

    label: { // 内容
      type: String,
      default: ''
    },

    width: { // 宽度  0-1会转%，大于1转px
      type: Number,
      default: 134
    },

    height: { // 高度
      type: Number,
      default: 60
    },

    to: {
      type: [String, Object],
      default: ''
    },

    htmlType: {
      type: String,
      default: 'button'
    },

    disabled: {
      type: Boolean,
      default: false
    }
  },

  emits: ['click'],

  setup (props, ctx) {
    const { widthC, heightC } = useSize(toRef(props, 'width'), toRef(props, 'height'))
    const styleC = computed(() => {
      const style = { ...props.popStyle }
      if (props.large) {
        style.width = '300px'
        style.height = '110px'
      } else {
        if (props.width !== 0) {
          style.width = widthC.value
        }
        if (props.height !== 0) {
          style.height = heightC.value
        }
      }
      switch (props.comp) { // 内置组合
        case 'function':
          style.width = 'auto'
          style.height = ''
          break
        default:break
      }

      if (props.circleRadius) {
        style.borderRadius = `${props.circleRadius}px`
      }
      if (props.circle) { // circle默认6px
        style.borderRadius = '6px'
      }
      if (props.bold > 0) {
        style.fontWeight = props.bold + 'px'
      } else if (props.bold < 0) {
        style.fontWeight = 'bold'
      }
      if (props.font !== 0) {
        style.fontSize = `${props.fontSize}px`
      }
      if (THEME[props.type].includes('-bd-')) { // border
        style.borderWidth = '1px'
        style.borderStyle = 'solid'
      }
      return style
    })

    const classC = computed(() => {
      const style = THEME[props.type]
      let comp = null
      if (props.comp) {
        comp = 'sp-button-' + props.comp
      }
      return [style, comp]
    })
    const router = useRouter()
    const useFunction = () => {
      const go = () => {
        if (props.to) {
          if (typeof props.to === 'string') {
            if (props.to?.slice(1) !== '/') {
              router.push({ name: props.to })
            } else {
              router.push({ path: props.to })
            }
          } else {
            router.push(props.to)
          }
        }
        if (props.type === 'back') {
          router.go(-1)
        }
      }
      const clickHandler = (e) => {
        go()
        ctx.emit('click')
      }
      return { go, clickHandler }
    }

    return {
      widthC, heightC, styleC, classC, ...useFunction()
    }
  }

}
</script>

<style scoped lang="less">
button{
  outline: none;
  border: none;
}
.SpButton{
  // display: inline-flex !important;
  .label{
    padding:0 10px;
  }
  &[disabled] {
    opacity: 0.8;
    cursor: not-allowed;
  }
}
.sp-button-normal{
  width:100px;
  height:40px;
  border-radius: 5px;
}
.sp-button-function{
  border-radius : 40px;
  height : 44px;
  padding : 0 20px;
  margin-right : 20px;
  font-size: 18px;
  font-family: Arial;
  font-weight: 400;
  color: #000000;
}
.sp-button-warn-1 {
  background: #FED47E;
  color: #676767
}
.sp-button-warn-active-1 {
  background: #FCE3B0;
  color: #000000;
}
.color-bg-yellow{
  background: #F6EECD;
  border: 1px solid #EDCB41;
}
.btb-error{
  background: #F8D3D3;
  border: 1px solid #FF0000;
}
</style>
